require('./focusable');

(($) => {

    $.fn.skipNavigation = function () {
        const skip = $(this);
        const others = $('main').focusable();
        if (others.length <= 0) {
            skip.attr('disabled', true);
        }
        else {
            skip.on('click', event => {
                others.eq(0).focus();
            });
        }
    };

})(jQuery);
